import { render, staticRenderFns } from "./SendAllModal.vue?vue&type=template&id=1b3f2af4"
import script from "./SendAllModal.vue?vue&type=script&lang=js"
export * from "./SendAllModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports